import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Container, Grid, useTheme, useMediaQuery } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const ModernHero = ({ posts }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isDark = theme.palette.mode === 'dark';

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % posts.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [posts.length]);

  if (!posts || posts.length === 0) return null;

  const currentPost = posts[currentIndex];
  const postUrl = currentPost.isExternal ? `/news/${currentPost.id}` : `/blog/${currentPost.slug}`;
  const highResImage = currentPost.featured_image 
    ? currentPost.featured_image.replace(/\d+x\d+/, '1920x1080')
    : 'https://source.unsplash.com/1920x1080/?technology,future';

  return (
    <div className="parallax" style={{backgroundImage:`url(${highResImage})`,height:'85vh',minHeight:600}}>
      <motion.div style={{position:'absolute',inset:0,background:'rgba(0,0,0,.5)'}}/>
      <Container maxWidth="xl" style={{position:'relative',zIndex:2,height:'100%',display:'flex',alignItems:'center'}}>
        <motion.div initial={{opacity:0,y:50}} animate={{opacity:1,y:0}} transition={{duration:1}} key={currentIndex}>
          <motion.h1 
            style={{
              fontSize: isMobile ? '1.8rem' : '3.5rem',
              fontWeight: 800,
              background: `linear-gradient(135deg,${isDark?'#00F5FF':'#FF3FA3'},${isDark?'#FF00C1':'#00CFFF'})`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              marginBottom: 24,
              maxWidth: '100%',
              wordWrap: 'break-word',
              whiteSpace: 'normal',
              lineHeight: 1.2
            }}
          >
            {currentPost.title}
          </motion.h1>
          <Link to={postUrl} style={{textDecoration:'none'}}>
            <motion.button whileHover={{scale:1.05}} whileTap={{scale:.95}} className="pulse" style={{background:`linear-gradient(135deg,${isDark?'#00F5FF':'#FF3FA3'},${isDark?'#FF00C1':'#00CFFF'})`,color:'#000',fontWeight:800,padding: isMobile ? '12px 24px' : '16px 32px',borderRadius:50,border:'none',fontSize: isMobile ? '0.9rem' : '1.1rem',cursor:'pointer'}}>
              Leer Artículo
            </motion.button>
          </Link>
        </motion.div>
      </Container>
    </div>
  );

};

export default ModernHero;
